import { MULTIVERSE_SOCKET_PATH } from '../const/environments.constants';

export const socketSettings = {
    path: MULTIVERSE_SOCKET_PATH,
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000,
    forceNew: false,
    autoConnect: true,
};
